import { FC } from "react"
import { BtnEvent } from "../../api/EventTypes"
interface IProps {
  title: string
  onClick: (e: BtnEvent) => void
}
const ModalHeader: FC<IProps> = ({ title, onClick }) => {
  return (
    <header className="ocs-modal-header custom-header">
      <h2 className="ocs-heading-sm-grey">{title}</h2>

      <button
        className="material-icons MuiIcon-root ocs-md-btn-icon"
        onClick={onClick}
      >
        close
      </button>
    </header>
  )
}

export default ModalHeader
